import React from "react";
import {
  Users,
  TrendingUp,
  Globe2,
  Heart,
  Briefcase,
} from "lucide-react";
import { benefits } from "../data/mock";

const iconMap = {
  Users,
  TrendingUp,
  Globe2,
  Heart,
  Briefcase,
};

const BenefitsRow = () => {
  return (
    <section className="relative -mt-2 lg:-mt-4 z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="bg-white rounded-2xl shadow-[0_20px_60px_-30px_rgba(15,23,42,0.18)] ring-1 ring-slate-100 px-6 lg:px-10 py-8 lg:py-10">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-6">
            {benefits.map((b, idx) => {
              const Icon = iconMap[b.icon];
              return (
                <div
                  key={b.id}
                  className={`flex items-start gap-4 fade-up delay-${Math.min(
                    idx + 1,
                    5
                  )}`}
                >
                  <div
                    className={`flex-shrink-0 w-12 h-12 rounded-full ${b.bg} flex items-center justify-center`}
                  >
                    <Icon className={`w-5 h-5 ${b.iconColor}`} strokeWidth={2.2} />
                  </div>
                  <div>
                    <h3 className="font-display text-[15px] font-bold text-slate-900">
                      {b.title}
                    </h3>
                    <p className="mt-1 text-[13px] leading-relaxed text-slate-500">
                      {b.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsRow;
